module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/download-types/download-type-list/download-type-list.component.scss
// module id = ./libs/atenea-cms-brand/src/download-types/download-type-list/download-type-list.component.scss
// module chunks = main